import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-hometwo-services',
    templateUrl: './hometwo-services.component.html',
    styleUrls: ['./hometwo-services.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HometwoServicesComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "Our Services",
            title: 'We Offer Professional Solutions For Business',
            paragraphText: 'Our skilled tech resources would get involve with yiu and provide the best solution for your business needs.'
        }
    ]
    singleServicesItem: ServicesItem[] = [
        {
            icon: 'assets/img/services/icon1.png',
            title: 'Web Development',
            paragraphText: 'Transform your digital landscape with tailored web solutions that drive engagement and growth.',
            btnIcon: 'flaticon-right',
            btnText: 'Read More',
            link: 'services-details'
        },
        {
            icon: 'assets/img/services/icon2.png',
            title: 'Dedicated Development Team',
            paragraphText: 'Empower your projects with a dedicated development team committed to excellence.',
            btnIcon: 'flaticon-right',
            btnText: 'Read More',
            link: 'services-details'
        },
        {
            icon: 'assets/img/services/icon3.png',
            title: 'AI & ML Development',
            paragraphText: 'Drive innovation with our AI & ML development solutions tailored to meet your business needs.',
            btnIcon: 'flaticon-right',
            btnText: 'Read More',
            link: 'services-details'
        },
        // {
        //     icon: 'assets/img/services/icon4.png',
        //     title: 'Real Time Analytics',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna doloresssit amet aliqua.',
        //     btnIcon: 'flaticon-right',
        //     btnText: 'Read More',
        //     link: 'services-details'
        // },
        // {
        //     icon: 'assets/img/services/icon5.png',
        //     title: 'Big Data Analytics',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna doloresssit amet aliqua.',
        //     btnIcon: 'flaticon-right',
        //     btnText: 'Read More',
        //     link: 'services-details'
        // },
        // {
        //     icon: 'assets/img/services/icon6.png',
        //     title: 'Business Analytics',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna doloresssit amet aliqua.',
        //     btnIcon: 'flaticon-right',
        //     btnText: 'Read More',
        //     link: 'services-details'
        // }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class ServicesItem {
    icon : string;
    title : string;
    paragraphText : string;
    btnIcon : string;
    btnText : string;
    link : string;
}